import { renderInvalidatedColors } from './chart-util';

/**
 * Adds options for BAR and COLUMN charts.
 */

export function preRender(data, options) {
  const bar = data.plotOptions[options.type];
  bar.stacking = options.stacking;
  bar.marker = {
    enabled: false
  };
  bar.borderWidth = 0;
  // data = adjustBarsWidth(data, options);
  data.plotOptions[options.type].pointPadding = 0.125;
  data.plotOptions[options.type].groupPadding = options.series.length > 1 && 
    options.stacking === null ? 0.2 : 0;
  return data;
}

// For bar charts, tweaks the spacing between bars.
// function adjustBarsWidth(data, options) {
//   if (options.type === 'column') {
//     const c = data.plotOptions[options.type];
//     const seriesLen = options.stacking ? 1 : data.series.length;
//     let maxDataLen = 0;
//     data.series.forEach(item => {
//       maxDataLen = Math.max(maxDataLen, item.data.length);
//     });
//     const yAxisEstimate = getYAxisEstimatedWidth(data, options);
//     const xAxisWidth = options.width - yAxisEstimate;
//     const bars = seriesLen * maxDataLen;
//     const groupBars = (seriesLen > 1) ? (maxDataLen - 1) : 0;
//     const pointBars = (seriesLen === 1) ? (maxDataLen - 1) :
//       (maxDataLen * (seriesLen - 1));

//     const adjustedGroupBars = groupBars * 2;
//     // designed = 0.25 :
//     const adjustedPointBars = pointBars * (0.35 + 0.2 * seriesLen);

//     c.pointWidth = Math.max(2, xAxisWidth /
//       (bars + adjustedGroupBars + adjustedPointBars));
    
//     // if (options.legend.enabled && options.legend.layout === 'right') {
//     //   c.pointWidth = c.pointWidth + (c.pointWidth * 0.25);
//     // } else {
//     //   c.pointWidth = c.pointWidth + (c.pointWidth * 0.5)
//     // }
    

//     // let factorToSubtractBy = 0;

//     // if (data.series[0].data.length > 100) {
//     //   if (options.width < 500) {
//     //     factorToSubtractBy = 0.95;
//     //   }
//     //   if (options.width < 620 && options.width > 500) {
//     //     factorToSubtractBy = 0.75;
//     //   }
//     //   if (options.width >= 620) {
//     //     factorToSubtractBy = 0.25;
//     //   }
//     // }

//     // if ((options.legend.enabled && options.legend.layout === 'right') && data.series[0].data.length > 100) {
//     //   if (options.width < 500) {
//     //     factorToSubtractBy = 0.95;
//     //   }
//     //   if (options.width < 620 && options.width > 500) {
//     //     factorToSubtractBy = 0.9;
//     //   }
//     //   if (options.width === 620) {
//     //     factorToSubtractBy = 0.7;
//     //   }
//     //   if (options.width > 620) {
//     //     factorToSubtractBy = 0.25;
//     //   }
//     // }

//     // if ((options.legend.enabled && options.legend.layout === 'right') && data.series[0].data.length < 100) {
//     //   factorToSubtractBy = options.width < 420 ? 0.35 : 0.25;
//     // }
    
//     // c.pointWidth = c.pointWidth - (c.pointWidth * factorToSubtractBy);
//     // c.pointPadding = 0.5;
//     // c.groupPadding = 0;
    
//   }
//   return data;
// }

function getYAxisEstimatedWidth(data, options) {
  let maxNum = 0;
  data.series.forEach(series => {
    for (let i = 0; i < series.data.length; i++) {
      maxNum = Math.max(maxNum, series.data[i].y);
    }
  });
  maxNum = (Math.round(maxNum) + '').length;
  const units = options.axes.units;
  const forceDecimals = (units.forceDecimals !== undefined) ?
    units.forceDecimals : 0;
  const maxDecimals = (units.maxDecimals !== undefined) ?
    units.maxDecimals : Number.MAX_VALUE;
  const len = maxNum + Math.min(forceDecimals, maxDecimals);
  const fontSize = parseFloat(options.styles.normal.fontSize) * 0.5;
  return len * fontSize;
}

export function postRender(highchart, options) {
  if (options.type === 'column') {
    adjustBarSpacing(highchart, options);
  }
  stylizeStacks(highchart, options);
}

export function renderInvalidated(rendered, options, invalidated) {
  if (__ALL__) {
    renderInvalidatedColors(rendered, invalidated);
  }
}

// Tweak spacing to improve rounding/pixel issues.
function adjustBarSpacing(highchart, options) {
  const axis = highchart.yAxis[0];
  const delta = {
    index1: -1,
    index2: -1,
  };
  // Set X for each bar to NOT rounded position. I thought this would look
  // terrible, but it's fine.
  const seriesLen = axis.series.length;
  axis.series.forEach(series => {
    for (let i = 0; i < series.data.length; i++) {
      const point = series.data[i];
      if (point.graphic) {
        point.graphic.element.setAttribute('x', point.barX);
        // Measure the distance between bars:
        if (delta.index1 === -1) {
          delta.index1 = i;
          delta.bar1 = point.barX;
        } else if (delta.index2 === -1) {
          if (delta.index1 < i - 1) {
            delta.index1 = -1;
          } else {
            delta.index2 = i;
            delta.bar2 = point.barX - point.pointWidth;
          }
        }
      }
    }
  });
  // if (delta.index1 !== -1 && delta.index2 !== -1) {
  //   // If bars are too close together, merge them:
  //   const deltaPx = delta.bar2 - delta.bar1;
  //   console.log(deltaPx);
  //   const hasOverOneFiftyDataPoints = options.series[0].data.length > 150 ? 1.5 : 0.5;
  //   console.log(deltaPx, options.size);
  //   if (deltaPx < hasOverOneFiftyDataPoints) {
  //     axis.series.forEach(series => {
  //       for (let i = 0; i < series.data.length; i++) {
  //         const point = series.data[i];
  //         if (point.graphic) {
  //           let isLegendRight = options.legend.enabled && options.legend.layout === 'right' ? 0.25 : 0.125;
  //           isLegendRight = options.series[0].data.length > 150 ? isLegendRight + 0.05 : isLegendRight;
  //           point.graphic.element.setAttribute('x', point.barX + (deltaPx / 2));
  //           point.graphic.element.setAttribute('width', point.pointWidth - deltaPx);
  //         }
  //       }
  //     });
  //   }
  // }
}

// If stacking is enabled, adjust the style of the stacks.
function stylizeStacks(highchart, options) {
  if (options.stacking) {
    highchart.yAxis[0].series.forEach(series => {
      series.data.forEach(item => {
        if (item.graphic) {
          const el = item.graphic.element;
          const px = parseFloat(el.attributes.height.value);
          if (px > 0) {
            el.setAttribute('height', px - 1);
          }
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/chart/inner/chart-bar.js